import { ButtonType } from '../constants/ButtonType'
import { NodeType } from '../constants/NodeType'
import { NextStepType } from '../models/Source/constants'

export function isNextStepTypeUrl(
  nextStepType: NextStepType | ButtonType | NodeType | null,
): nextStepType is NextStepType.URL | NextStepType.CTA_URL {
  return [NextStepType.URL, NextStepType.CTA_URL].includes(nextStepType as NextStepType)
}
